import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const LyricsGlowScaleListItem = (props) => {
    const { glowSettingsScale, updateLyricsStyle, maxGlowScale } = props;
    
    const onGlowScaleChange = (value) => {
        previewHistoryBatch.start();
        
        updateLyricsStyle({ 
            glowSettings: { scale: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Scale'
            value={glowSettingsScale}
            displayMultiplier={100 / maxGlowScale}
            min={0}
            max={100}
            step={1}
            onValueChange={onGlowScaleChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { glowSettings } = state.createPreview.present.videoSettings.lyrics.style;
    const glowSettingsScale = glowSettings ? glowSettings.scale : 0;
    const { maxGlowScale } = state.create.maxValues;

    return { 
        glowSettingsScale,
        maxGlowScale
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsGlowScaleListItem);
